import { useT } from "../i18n/I18nContext";

export function OnboardingNotice() {
  const t = useT();
  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <strong>{t("onboarding.title")}</strong> {t("onboarding.body")}
    </div>
  );
}
